import type { BookingSearchDTO } from '@/types/dto/agent';
import type { CustomerProfileApplyModelDTO } from '@/types/dto/retailer';

export type ProfileBookingType =
  | 'tickets'
  | 'travelPasses'
  | 'vouchers'
  | 'accountDetails';
export type ProfileBookingTimeType = 'active' | 'history';

// The body of the self-service profile update (PUT /retailer/customer-profile).
// `password` and `externalLogin` are excluded at the type level: both have their
// own dedicated flows and must never ride along on a profile save.
export type UpdateCustomerProfileRequest = Omit<
  CustomerProfileApplyModelDTO,
  'password' | 'externalLogin'
>;

export interface BookingSearchResponse {
  data: Array<BookingSearchDTO>;
  totalCount: number;
}

export enum ProfileGenderOptions {
  MALE = 'SEX.MALE',
  FEMALE = 'SEX.FEMALE',
  X = 'SEX.X',
}
